"use strict";

var CalendarDropdown = require("app/screens/Integration/components/GoogleCalendar/calendar-dropdown");

var CalendarSelector = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    calendarList: React.PropTypes.array.isRequired,
    value: React.PropTypes.string.isRequired,
    handleChange: React.PropTypes.func.isRequired
  },

  render: function() {
    return (
      <div>
        <div className="googleCalendar-settings-topicTitle">Qual agenda do Google deseja sincronizar?</div>
        <CalendarDropdown
          options={this.props.calendarList}
          handleChange={this.props.handleChange}
          value={this.props.value}/>
      </div>
    );
  }
});

module.exports = CalendarSelector;



// WEBPACK FOOTER //
// ./app/screens/Integration/components/GoogleCalendar/calendar-selector.jsx